import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const TierSettings: React.FC = () => {
  return (
    <Card className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Subscription Plan</h2>
        <Badge variant="outline" className="bg-blue-50 text-blue-700 hover:bg-blue-50">Free Tier</Badge>
      </div>
      
      <div className="space-y-6">
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="text-lg font-medium mb-2">Your Current Plan</h3>
          <p className="text-gray-600 mb-4">
            You are currently on the <strong>Free Tier</strong> plan. This includes:
          </p>
          
          <ul className="list-disc pl-5 space-y-1 text-gray-600 mb-4">
            <li>Up to 10 scheduled posts per month</li>
            <li>Basic analytics</li>
            <li>Single user account</li>
            <li>1 connected social platform</li>
          </ul>
          
          <div className="text-sm text-gray-500">
            Upgrade to Pro for unlimited posts, advanced analytics, team collaboration, and more.
          </div>
        </div>
        
        <div className="border rounded-lg p-4">
          <h3 className="text-lg font-medium mb-4">Pro Plan</h3>
          
          <div className="flex items-baseline mb-4">
            <span className="text-2xl font-bold">$19</span>
            <span className="text-gray-600 ml-1">/month</span>
          </div>
          
          <ul className="list-disc pl-5 space-y-1 text-gray-600 mb-6">
            <li>Unlimited scheduled posts</li>
            <li>Advanced analytics and reporting</li>
            <li>Up to 3 team members</li>
            <li>Connect up to 5 social platforms</li>
            <li>Priority customer support</li>
            <li>AI content generation</li>
          </ul>
          
          <Button className="w-full">Upgrade to Pro</Button>
        </div>
        
        <div className="border rounded-lg p-4">
          <h3 className="text-lg font-medium mb-4">Enterprise Plan</h3>
          
          <div className="flex items-baseline mb-4">
            <span className="text-2xl font-bold">$49</span>
            <span className="text-gray-600 ml-1">/month</span>
          </div>
          
          <ul className="list-disc pl-5 space-y-1 text-gray-600 mb-6">
            <li>Everything in Pro</li>
            <li>Unlimited team members</li>
            <li>Connect unlimited social platforms</li>
            <li>Custom integrations</li>
            <li>Dedicated account manager</li>
            <li>Custom analytics dashboard</li>
          </ul>
          
          <Button variant="outline" className="w-full">Contact Sales</Button>
        </div>
      </div>
    </Card>
  );
};

export default TierSettings; 